import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { stage } from "../../assets/globalHelpers";
import "../../assets/css/argon-dashboard-react.css"
import "../../assets/css/diagramms/setDiagram.css"
import { stagesNames } from "../translation.js"
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "context/DarkModeProvider";
import axiosInstance from "apiHandles/axiosInstance";

function SetDiagram({ items = [], finalStages, onItemClick }) {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();
  const { darkMode } = useDarkMode();
  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  const colorScheme = {
    primary: '#84cc16',
    secondary: '#65a30d',
    accent: '#ecfccb'
  };

  const handleItemClick = (index) => {
    if (onItemClick) {
      onItemClick(index);
      return;
    }

    const stage = finalStages[index];
    if (!stage) {
      console.error("No stage found at index:", index);
      return;
    }

    // ✅ Αποθηκεύουμε ΜΟΝΟ το ID
    localStorage.setItem("stageLocation", stage.name);
    localStorage.setItem("selectedStageId", stage.id);  // ✅ Μόνο ID

    navigate("/admin/index");
  };

  return (
    <div className="setDiagramContainer">
      <div className="setDiagramContent">
        <span
          className="setSymbol"
          style={{ color: colorScheme.primary }}
        >
          {`Set = {`}
        </span>

        {items.map((item, index) => (
          <React.Fragment key={index}>
            <button
              className="setItemButtonSetDiagram"
              onClick={() => handleItemClick(index)}
              style={{
                background: `linear-gradient(135deg, ${colorScheme.primary}15 0%, ${colorScheme.secondary}10 100%)`,
                backdropFilter: 'blur(10px)',
                border: `1px solid ${colorScheme.primary}30`,
                color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
                transform: hoveredIndex === index
                  ? "scale(1.05) translateY(-2px)"
                  : "scale(1)",
                boxShadow: hoveredIndex === index
                  ? `0 0px 10px ${colorScheme.primary}40, 0 0 0 1px ${colorScheme.primary}20`
                  : `none`,
                cursor: 'pointer',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {selLanguage ? stagesNames[item.toLowerCase()] : item}
            </button>
            {index < items.length - 1 && (
              <span
                className="setComma"
                style={{ color: colorScheme.primary }}
              >
                ,
              </span>
            )}
          </React.Fragment>
        ))}

        <span
          className="setSymbol"
          style={{ color: colorScheme.primary }}
        >
          {`}`}
        </span>
      </div>
    </div>
  );
}

export default SetDiagram;